export default __webpack_public_path__ + "static/media/stayatstar.586530d3.svg";